module.exports = __webpack_public_path__ + "img/bg_auth_mobile.0fa94989.svg";